import "./App.css";
import Home from "./Screens/Home.tsx";
import AOS from "aos";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
